import { Typography } from "@material-ui/core";
import { Box, Button, Container, Grid } from "@mui/material";

import React from "react";
import SendIcon from "@mui/icons-material/Send";
// import ApplyFellowShipModal from "./ApplyFellowShipModal";
import "../FellowShip/fellowship.css";
import { Link } from "react-router-dom";
import "../FellowShip/banner.css";
import { DateTime } from "luxon";

const UnwindMindBanner = () => {
  const [open, setOpen] = React.useState(false);
  const submissionDate = DateTime.fromISO(new Date().toISOString());
  const currentDate = DateTime.fromISO("2024-10-04");

  return (
    <div>
      <Container maxWidth="xl">
        <Box>
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
            columns={{ lg: 10, md: 10, xl: 10, xs: 10, sm: 10 }}
            spacing={1}
          >
            <Grid
              item
              xs={10}
              lg={10}
              sm={10}
              md={10}
              xl={10}
              sx={{ textAlign: "center" }}
            >
              <img
                src="https://firebasestorage.googleapis.com/v0/b/psycure-58e6d.appspot.com/o/unwind--mind%2Funwind-mind-event.jpg?alt=media"
                alt=""
                width="60%"
                className="banner-logo"
              />
            </Grid>
            <Grid
              item
              xs={10}
              lg={10}
              sm={10}
              md={10}
              xl={10}
              sx={{ textAlign: "center" }}
            >
              <Typography
                variant="h6"
                style={{
                  textTransform: "uppercase",
                }}
                className="deadline"
              >
                Application Deadline: October 04, 2024
                <br />
                <div style={{ margin: "3% 0" }}>
                  {submissionDate < currentDate ? (
                    <a
                      href="https://forms.gle/mkrV6BrD9mouoWMj6"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Button
                        // variant="contained"
                        sx={{
                          width: "300px",
                          height: "50px",
                          background: "#3cb669",
                          borderRadius: "20px",
                          color: "white",
                        }}
                        endIcon={<SendIcon />}
                        className="fellowship-button"
                      >
                        Apply Now!
                      </Button>
                    </a>
                  ) : (
                    <Typography variant="h5" style={{ color: "red" }}>
                      {/* Registration deadline passed */}
                    </Typography>
                  )}
                </div>
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
};

export default UnwindMindBanner;
